export default __webpack_public_path__ + "static/media/callencryptSm.af462c6b.svg";